import React from 'react';
 import { Swiper, SwiperSlide } from 'swiper/react';
 import 'swiper/css';
 import 'swiper/css/pagination';
 import 'swiper/css/navigation';
 import './Home.css';
 import { Autoplay, Pagination, Navigation } from 'swiper/modules';
 
 function Home() {
   return (
     <>
     <Swiper
       spaceBetween={30}
       centeredSlides={true}
       autoplay={{
         delay: 3500,
         disableOnInteraction: false,
       }}
       pagination={{
         clickable: true,
       }}
       navigation={false}
       modules={[Autoplay, Pagination, Navigation]}
       className="mySwiper">
       <SwiperSlide className='SwiperSlide'><img src='bannière.png'  alt='bannière' /></SwiperSlide>
       <SwiperSlide className='SwiperSlide'><img src='slider3.png' alt='bannière' /></SwiperSlide>
     </Swiper>
     </>

     
   );
 };
 
 export default Home;
 
 
 
 
 
 
 
 
 
 


// import React from 'react';
// import './Home.css'
// function Home() {
//   return (
//     <>
//       <div  id='Home' className='Slide'>
//         <img src='bannière.png'  alt='bannière' />
//       </div>
//     </>
//   );
// };

// export default Home;
